import { WarningOutlined } from "@ant-design/icons";
import { Flex, Switch } from "antd";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { ActivateCallback } from "src/types/ActivateCallback";

import { ZAttrMeta } from "../ZAttrMeta";
import { ZAttrSwitch } from "./ZAttrComponent";

type PropsAttrEditSwitch = {
  attrMeta: ZAttrMeta;
  value: unknown;
  onChange?(newValue: unknown): void;
  disabled?: boolean;
  activateCallback?: ActivateCallback;
  component?: ZAttrSwitch;
  textCvt?(text: string): string;
  onBlur: () => void;
};

export const AttrEditSwitch: React.FC<PropsAttrEditSwitch> = observer(
  (props) => {
    const { value, onChange, disabled, textCvt, component, attrMeta, onBlur } =
      props;
    const cvt = (text: string | null | undefined) => {
      if (!text) return undefined;
      return textCvt?.(text) ?? text;
    };
    const wrongType = attrMeta.type.name !== "boolean";
    return (
      <Flex align="center" gap={10}>
        <Switch
          value={value as boolean}
          onChange={(b) => {
            onChange?.(b);
            onBlur();
          }}
          disabled={disabled || wrongType}
          checkedChildren={cvt(component?.checkedText)}
          unCheckedChildren={cvt(component?.uncheckedText)}
        />
        {wrongType && (
          <span
            style={{ color: "red", fontSize: 24 }}
            title={`Компонент Switch может работать только с типом boolean, а получено: ${attrMeta.type.name}`}
          >
            <WarningOutlined />
          </span>
        )}
      </Flex>
    );
  },
);
